(function($){
    //if ( $('.banner').length > 0 ){
        let headerHeight = $('.siteheader').innerHeight() - 5;     
        $('body').css('padding-top', `${headerHeight}px` );
    //}
})(jQuery);